import React from 'react';
import { IBlockRegion } from '../utils';
import RankBadge from './RankBadge';

const TableBody = ({ isRanked, region }: { isRanked: boolean; region: IBlockRegion; }) => {
  return (
    <tbody>
      {
        isRanked ? (
          <tr>
            <td>1</td>
            <td>
              <RankBadge rank="Gold_1" />
              {region === 'landingPageBlock' && 'Gold 1'}
            </td>
            <td>Player 1</td>
          </tr>
        ) : (
          <tr>
            <td>1</td>
            <td>Player 1</td>
            <td>100</td>
            <td>100</td>
            <td>100</td>
            <td>100</td>
          </tr>
        )
      }
    </tbody>
  );
};

export default TableBody;
